//@ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as SortUp } from 'styles/icons/sort-up.svg';
import { ReactComponent as SortDown } from 'styles/icons/sort-down.svg';
import { SORT_MAP } from 'components/grid/api-list/hooks/list-context';

const style = {
  color: '#4a4a4a',
  height: '20px',
  width: '20px',
  padding: '5px',
};

const SortIcon = ({ sorted }) => {
  const display = Object.values(SORT_MAP).includes(sorted) ? 'initial' : 'none';

  const styles = { ...style, display };

  return sorted === SORT_MAP.DESC ? (
    <SortUp style={styles} data-type="sort-icon-up" />
  ) : (
    <SortDown style={styles} data-type="sort-icon-down" />
  );
};

SortIcon.propTypes = {
  sorted: PropTypes.string,
};

SortIcon.defaultProps = {
  sorted: undefined,
};

export default SortIcon;
